import { useQuery } from '@tanstack/react-query';

import { client } from '@/shared/http/client';

import type { StoreCoupon } from '../types/store-coupon';

/** Vitrine de cupons da loja (PRAT-110). Pública: funciona antes do login. */
export async function getStoreCoupons(slug: string): Promise<StoreCoupon[]> {
  const res = await client
    .get(`api/app/merchants/${encodeURIComponent(slug)}/coupons`)
    .json<{ data?: StoreCoupon[] }>();
  return Array.isArray(res?.data) ? res.data : [];
}

/**
 * Cupons visíveis da loja. Falha da vitrine nunca atrapalha o cardápio: em erro
 * a lista fica vazia e a faixa de benefícios só não mostra cupom.
 */
export function useStoreCoupons(slug: string | undefined) {
  return useQuery({
    queryKey: ['store-coupons', slug],
    queryFn: () => getStoreCoupons(slug!),
    enabled: !!slug,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}
